import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaChevronDown, FaAngleLeft, FaAngleRight, FaAngleDown } from 'react-icons/fa';

function DateRangeInput2(props) {

  const monthbuttonClass = "px-4 cursor-pointer";
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  return (
    <div className={props.wrapperClass} >
      {<label className={props.labelClass} htmlFor="{props.id}">{props.label} </label>}
      <div id={props.id} >
        <div className="flex items-center">
          <DatePicker
            className={props.datePickerClass}
            renderCustomHeader={({
              date,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled
            }) => (<div className="flex justify-around bg-black p-2 text-white">
              <div className={monthbuttonClass}
                onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                <FaAngleLeft />
              </div>
              {months[date.getMonth()]} {date.getFullYear()}
              <div className={monthbuttonClass}
                onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                <FaAngleRight />
              </div>
            </div>)}
            calendarClassName="bg-cruise_darkblue "
            dayClassName={date =>
              "text-white"}
            showPopperArrow={false}
            popperClassName="z-50"
            popperPlacement="auto"
            popperModifiers={
              {
                offset: {
                  enabled: true,
                  offset: props.popperOffset1
                },
                preventOverflow: {
                  enabled: true,
                  escapeWithReference: false,
                  boundariesElement: "viewport"
                }
              }
            }
            placeholderText="Select start"
            dateFormat="dd MMMM yyyy"
            selectsStart={false}
            showMonthYearPicker={false}
            showYearDropdown
            showWeekNumbers
            monthsShown={1}
            highlightDates={[{ "border border-yellow-500 rounded-full": [new Date()] }]}
            selected={props.valueMin}
            //startDate={props.valueMin}
            //endDate={props.valueMax}
            adjustDateOnChange={false}
            onChange={(date) => { props.onChange(props.idMin, date) }}
          >
          </DatePicker>
          <FaAngleDown size={16} className="text-white" />
        </div>
        <div className="flex items-center">
          <DatePicker
            className={props.datePickerClass}
            renderCustomHeader={({
              date,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled
            }) => (<div className="flex justify-around bg-black p-2 text-white">
              <div className={monthbuttonClass}
                onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                <FaAngleLeft />
              </div>
              {months[date.getMonth()]} {date.getFullYear()}
              <div className={monthbuttonClass}
                onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                <FaAngleRight />
              </div>
            </div>)}
            calendarClassName="bg-cruise_darkblue "
            dayClassName={date =>
              "text-white"}
            showPopperArrow={false}
            popperClassName="z-50"
            popperPlacement="auto"
            popperModifiers={
              {
                offset:
                {
                  enabled: true,
                  offset: props.popperOffset2
                },
                preventOverflow: {
                  enabled: true,
                  escapeWithReference: false,
                  boundariesElement: "viewport"
                }
              }
            }
            placeholderText="Select end"
            minDate={props.valueMin}
            selectsEnd={false}
            dateFormat="dd MMMM yyyy"
            showMonthYearPicker={false}
            showYearDropdown
            showWeekNumbers
            monthsShown={1}
            showPreviousMonths={true}
            selected={props.valueMax}
            //startDate={props.valueMin}
            //endDate={props.valueMin > props.valueMax ? props.valueMin : props.valueMax}
            openToDate={props.valueMin > props.valueMax ? props.valueMin : props.valueMax}
            adjustDateOnChange={false}
            onChange={(date) => { props.onChange(props.idMax, date) }}
          />
          <FaAngleDown size={16} className="text-white"/>
        </div>
      </div>
      {props.error.length > 0 && <div className="alert alert-danger">{props.error}</div>}
    </div>
  );
}

DateRangeInput2.defaultProps = {
  error: ""
}

export default DateRangeInput2;